import { Button } from 'react-bootstrap';
import { FormattedNumber } from 'react-intl';
import { FaSpinner } from 'react-icons/fa';
import React = require('react');
import { get } from 'lodash';
import { CallNowButton } from '../CallNowButton';

export const DiscountRefund = ({ selectedScheme, isLoading, hasErrors, handleIssue, renewal = false, ...props }) => {

  const refundAmount = Math.abs(get(selectedScheme, 'premium.gross', get(selectedScheme, 'gross', 0.00)));
  const currency = get(selectedScheme, 'premium.currency', 'GBP');

  const renderRefund = () => {
    const discountedPriceText = renewal ? 'Your discounted Renewal price (inc. IPT)' : 'Refund amount (inc. IPT)'
    if (!hasErrors && refundAmount > 0) {
      return (
        <>
          <div className={'discount-refund-container'} style={{ marginTop: '30px' }}>
            <div className={'text'}><b>{discountedPriceText}</b>{'  '} <b>
              <FormattedNumber
                value={refundAmount}
                style="currency"
                currency={currency}
              /></b>
            </div>
            <div className={'button'}>
              {renderDiscountConfirmButton()}
            </div>
          </div>
        </>
      )
    }

    if (hasErrors) {
      return (
        <div className={'discount-refund-container'}>
          <div className={'text'}>
            Sorry, there has been an issue with your discount
          </div>
          <div className={'button'}>
            <CallNowButton/>
          </div>
        </div>
      )
    }

  }

  const handleConfirmDiscountButton = () => {
    handleIssue();
  }

  const renderDiscountConfirmButton = () => {
    const { submitting, submitFailed, valid, isLoading } = props;
    return (
      <Button
        bsStyle="primary"
        type="button"
        bsSize="small"
        className="medium-width"
        onClick={handleConfirmDiscountButton}
        disabled={submitting || (submitFailed && !valid || !valid || isLoading)}>
        {isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        {renewal ? 'APPLY PRICE' : 'CONFIRM'}
      </Button>
    )
  }

  return (
    <>
      {renderRefund()}
    </>
  )
}
